module.exports = __webpack_public_path__ + "img/ics_o_arrow_right_red.840b84e1.svg";